module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "Research.7cb7c7a9.svg";